import { Switch } from "@mui/material";

import pages from "../../../../../constants/pages";
import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";
import RuleDataGridLongTextCell from "../../../../rule-library/RuleDataGridLongTextCell";

export const groupRuleColumns = ["actions", "name", "active", "updatedAt", "createdAt", "platform"];

export const getGroupRulesColumns = (
	loading,
	handleRuleStatusToggle,
	removeRuleFromGroup,
	navigate
) => [
	{
		editable: false,
		field: "name",
		flex: 1,
		sortable: true,
		headerName: "Rule Name",
		pinnable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "platform",
		headerName: "Platform",
		flex: 1,
		sortable: true,
		valueGetter: (params) => params?.name,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<RuleDataGridLongTextCell value={params.row.platform?.name || " "} />
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "ruleLocation",
		headerName: "Location",
		flex: 1,
		sortable: true,
		valueGetter: (params) => params?.name,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.value} />}
				isLoading={loading}
			/>
		)
	},
	{
		editable: true,
		field: "active",
		headerName: "Status",
		width: 100,
		sortable: true,
		pinnable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<Switch
						checked={params.row.active}
						disabled={true}
						onChange={() => handleRuleStatusToggle(params.row.id, params.row.active)}
					/>
				}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "updatedAt",
		flex: 1,
		headerName: "Modified",
		sortable: true,
		pinnable: false,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "createdAt",
		flex: 1,
		headerName: "Created",
		sortable: true,
		pinnable: false,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "actions",
		disableExport: true,
		type: "actions",
		sortable: false,
		flex: .1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div>
						<ThreeDotMenu
							options={[
								{
									name: "Remove From Group",
									optionClickHandler: () => {
										removeRuleFromGroup(params.row.id);
									},
								},
								{
									name: "View Rule",
									optionClickHandler: () => {
										navigate(pages.editRule(params.row.id));
									},
								},
							]}
						/>
					</div>
				}
				isLoading={loading}
			/>
		),
	},
];